import React, { useState } from "react";
import { ChevronDown, ShieldCheck, Star } from "lucide-react";
import {
  REFUND_DAYS,
  getAccessBenefitLabel,
  getAccessDurationLabel,
} from "../../config/subscription.js";
import "./offer_summary.css";

const formatBRL = (value) => {
  const number = parseFloat(value);
  if (Number.isNaN(number)) return value;
  return number % 1 === 0
    ? number.toFixed(0)
    : number.toFixed(2).replace(".", ",");
};

const OfferSummary = ({ offer, isMobile, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);

  const instalment12x = offer.prices.credit_card[12];
  const instalment12xLabel =
    instalment12x % 1 === 0
      ? parseFloat(instalment12x).toFixed(0)
      : parseFloat(instalment12x).toFixed(2).replace(".", ",");

  const totalCreditCard = parseFloat(instalment12x) * 12;
  const pixPrice = parseFloat(offer.prices.pix);
  const pixDiscount = Math.round(
    ((totalCreditCard - pixPrice) / totalCreditCard) * 100
  );

  const benefits = [
    "Acesso completo a todos os cursos (mais de 100 horas de conteúdo)",
    "Circuitos elétricos I, II e III (teoria, exercícios e experimentos)",
    "Suporte tira-dúvidas com o Prof. Nicholas Yukio",
    getAccessBenefitLabel(offer.period),
    "Certificados de conclusão",
  ];

  const priceBlock = (
    <div className="offs-price-block">
      <div className="offs-price-main">
        12x de <strong>R$ {instalment12xLabel}</strong>
      </div>
      <div className="offs-price-pix">
        ou R$ {formatBRL(offer.prices.pix)} à vista no Pix
        {pixDiscount > 0 && (
          <span className="offs-pix-badge">{pixDiscount}% OFF</span>
        )}
      </div>
    </div>
  );

  const benefitsList = (
    <ul className="offs-benefits">
      {benefits.map((benefit, i) => (
        <li key={i}>{benefit}</li>
      ))}
    </ul>
  );

  if (isMobile) {
    return (
      <div className={`offs-mobile ${open ? "open" : ""}`}>
        <button
          type="button"
          className="offs-mobile-header"
          onClick={() => setOpen((prev) => !prev)}
          aria-expanded={open}
        >
          <div className="offs-mobile-header-left">
            <img
              src="/dominio_eletrico_logo_2023_square_fundo_transparente.png"
              alt="Domínio Elétrico"
              className="offs-thumb"
            />
            <div>
              <div className="offs-mobile-title">Site Domínio Elétrico</div>
              <div className="offs-mobile-price">
                12x de R$ {instalment12xLabel}
              </div>
            </div>
          </div>
          <ChevronDown className="offs-chevron" size={22} />
        </button>

        <div className="offs-mobile-body">
          <div className="offs-social">
            <Star size={16} className="offs-star" /> Mais de{" "}
            <strong>1.000 alunos</strong>
          </div>
          {benefitsList}
          {priceBlock}
          <div className="offs-guarantee">
            <ShieldCheck size={18} /> Garantia incondicional de {REFUND_DAYS} dias.
          </div>
        </div>
      </div>
    );
  }

  return (
    <aside className="offs-desktop">
      <div className="offs-card">
        <div className="offs-desktop-head">
          <img
            src="/dominio_eletrico_logo_2023_square_fundo_transparente.png"
            alt="Domínio Elétrico"
            className="offs-thumb-lg"
          />
          <div>
            <h2 className="offs-desktop-title">
              Site Domínio Elétrico
            </h2>
            <p className="offs-desktop-subtitle">
              Acesso imediato a todos os cursos por {getAccessDurationLabel(offer.period)}.
            </p>
          </div>
        </div>

        <div className="offs-social">
          <Star size={16} className="offs-star" /> Mais de{" "}
          <strong>1.000 alunos</strong> no nosso site
        </div>

        {benefitsList}
        {priceBlock}

        <div className="offs-guarantee">
          <ShieldCheck size={18} />
          <span>
            <strong>Garantia incondicional de {REFUND_DAYS} dias.</strong> Se não gostar,
            devolvemos 100% do seu dinheiro.
          </span>
        </div>

        <div className="offs-payment-icons">
          <img src="/pix.png" alt="Pix" />
          <img src="/visa.png" alt="Visa" />
          <img src="/mastercard.png" alt="Mastercard" />
          <img src="/elo.png" alt="Elo" />
        </div>

        <div className="offs-trust">
          🔐 Ambiente seguro • Pagamento criptografado
        </div>
      </div>
    </aside>
  );
};

export default OfferSummary;
